import { render, staticRenderFns } from "./AddressBookSelector.vue?vue&type=template&id=712a20e2"
import script from "./AddressBookSelector.vue?vue&type=script&lang=js"
export * from "./AddressBookSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports